var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-input",attrs:{"title":_vm.label},on:{"mousedown":_vm.dragStart}},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon,"size":"12"}}):_vm._e(),_vm._v("\n\t"+_vm._s(_vm.label)+"\n\t"+_vm._s(_vm.value)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }